import { defaultColorSettings } from "../canvas/canvasUtils";
import { GRAYSCALE_MODES } from "../config/config";
import store from "../store";

export default class OverlayBrowserContext {
  constructor(images) {
    this.images = images;

    this.foreground = images[0];
    this.background = images.length > 1 ? images[1] : images[0];

    this.redColor = { name: "R", icon: "red-icon.png", ...defaultColorSettings(GRAYSCALE_MODES.Red, false) };
    this.greenColor = { name: "G", icon: "green-icon.png", ...defaultColorSettings(GRAYSCALE_MODES.Green, false) };
    this.blueColor = { name: "B", icon: "blue-icon.png", ...defaultColorSettings(GRAYSCALE_MODES.Blue, false) };
    this.colorSettingOptions = [this.redColor, this.greenColor, this.blueColor];
  }

  refreshImages() {
    return store.dispatch("loadOverlayImages");
  }

  selectForeground(image) {
    this.foreground = image;
  }

  selectBackground(image) {
    this.background = image;
  }
}